export default "__VITE_ASSET__68143ced__"